import React, { Fragment, forwardRef, useState, useEffect } from 'react';
import { useToggle } from 'helpers';
import { Logo, SignUpButton, OvertakeMenu } from '.';
import { Badge, Link, NavLink } from 'components';
import css from './header.scss';

export function Header(props) {
  const [ overtakeMenu, toggleOvertakeMenu ] = useToggle();
  const [ hasBackground, setHasBackground ] = useState();

  const dark = /privacy|terms|faq|about/.test(props.location.pathname);
  const fixed = !/login|sign-up|contact|restore/.test(props.location.pathname);

  useEffect(() => {
    if (props.refHeaderBreakpoint.current) {
      const observer = new IntersectionObserver(([{ intersectionRatio }]) => {
        setHasBackground(intersectionRatio == 0);
      });
      observer.observe(props.refHeaderBreakpoint.current);
      return () => observer.disconnect();
    }
  }, [ props.refHeaderBreakpoint.current ]);

  return (
    <Fragment>
      <div className={css('background', (hasBackground || dark) && 'show')} />
      <header className={css('header', { fixed })}>
        <div>
          <Link to="/">
            <Logo className={css.logo} />
          </Link>
        </div>
        <ul className={css('menu')}>
          <li><NavLink location={props.location} to="/overview/">Overview</NavLink></li>
          <li><NavLink location={props.location} to="/features/">Features</NavLink></li>
          <li><NavLink location={props.location} to="/programs/">Programs</NavLink></li>
          <li><NavLink location={props.location} to="/about/">About</NavLink></li>
          <li><NavLink location={props.location} to="/contact/">Contact</NavLink></li>
          <li><a target="_blank" href="https://successwizard.blog">Blog</a></li>
          <li><NavLink location={props.location} to="/sign-up/" className={css.signup}><SignUpButton /></NavLink></li>
          <li><NavLink location={props.location} to="/login/" className={css.login}>Login</NavLink></li>
        </ul>
        <div>
          <Badge.AppStore className={css.badge} />
          <Badge.GooglePlay className={css.badge} />
        </div>
      </header>
      <svg viewBox="0 0 100 100" className={css.burger} onClick={toggleOvertakeMenu}>
        { ['first', 'second', 'third'].map(key =>
          <path key={key} className={css(key, overtakeMenu && 'on')} d="M17.625,47 L82.375,47 C83.8247475,47 85,48.3431458 85,50 C85,51.6568542 83.8247475,53 82.375,53 L17.625,53 C16.1752525,53 15,51.6568542 15,50 C15,48.3431458 16.1752525,47 17.625,47 Z" />
        ) }
      </svg>
      <OvertakeMenu in={overtakeMenu} />
    </Fragment>
  );
}

Header.Compensate = forwardRef((props, ref) =>
  <div className={css('compensate', props)}>
    <div ref={ref} />
  </div>
);
